import React from "react";
import formatValue from "../../../utils/formatValue";
import { dashboardTheme } from "../theme/dashboardTheme";
import { IRevenueInsights } from "../types/ownerDashboard.types";
import { formatYearOverYearInsight } from "../utils/formatYearOverYearInsight";

interface RevenueInsightsSummaryProps {
  revenueInsights?: IRevenueInsights;
}

export default function RevenueInsightsSummary({
  revenueInsights,
}: RevenueInsightsSummaryProps) {
  const yearOverYear = formatYearOverYearInsight(revenueInsights?.year_over_year);
  const annualBalance = revenueInsights?.annual_balance;
  const rollingTotal = revenueInsights?.rolling_12_months_total;

  return (
    <div className="flex flex-col gap-1">
      {yearOverYear && (
        <>
          <p
            className="text-sm font-semibold"
            style={{
              color: yearOverYear.isPositive
                ? dashboardTheme.colors.positive
                : dashboardTheme.colors.negative,
            }}
          >
            {yearOverYear.headline}
          </p>
          <p className="text-xs text-[#8b949e]">{yearOverYear.comparisonLabel}</p>
        </>
      )}

      {!yearOverYear && (
        <p className="text-xs text-[#8b949e]">
          Variação anual disponível quando houver receita comparável no ano anterior
        </p>
      )}

      {(annualBalance || rollingTotal != null) && (
        <div className="mt-2 flex flex-col gap-0.5 text-xs text-[#8b949e] sm:flex-row sm:flex-wrap sm:gap-x-4">
          {annualBalance && (
            <span>
              Balanço {annualBalance.calendar_year}:{" "}
              <strong className="font-semibold text-[#f0f6fc]">
                {formatValue(annualBalance.total)}
              </strong>
            </span>
          )}
          {rollingTotal != null && (
            <span>
              Últimos 12 meses:{" "}
              <strong className="font-semibold text-[#f0f6fc]">
                {formatValue(rollingTotal)}
              </strong>
            </span>
          )}
        </div>
      )}
    </div>
  );
}
